import { API_BASE_URL } from "../config/api";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { clearAuthSession } from "../utils/auth";

function EngineerLogin() {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setIsSubmitting(true);

    try {
      const res = await axios.post(API_BASE_URL + "/api/auth/login", {
        email: identifier,
        password
      });

      if (res.data.role !== "engineer") {
        setErrorMessage("This account does not have engineer access.");
        setIsSubmitting(false);
        return;
      }

      clearAuthSession();
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("role", "engineer");
      localStorage.setItem("engineerName", res.data.engineerName || res.data.name || "Engineer");
      localStorage.setItem("engineerSession", "active");
      if (res.data.engineerEmail) {
        localStorage.setItem("engineerEmail", res.data.engineerEmail);
      }
      if (res.data.engineerId) {
        localStorage.setItem("engineerId", res.data.engineerId);
      }
      if (res.data.customerViewEnabled !== undefined) {
        localStorage.setItem("engineerCustomerViewEnabled", String(Boolean(res.data.customerViewEnabled)));
      }

      window.location.href = "/engineer-dashboard";
    } catch (error) {
      setErrorMessage(
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Login failed"
      );
      setIsSubmitting(false);
    }
  };

  return (
    <div className="theme-login-shell relative flex min-h-screen items-center justify-center overflow-hidden bg-[linear-gradient(145deg,_#03261c,_#0f3d2e_45%,_#0a1f1a)] px-4">
      <div className="absolute right-[-4rem] top-8 h-80 w-80 rounded-full bg-emerald-400/15 blur-3xl" />
      <div className="absolute bottom-0 left-[-5rem] h-80 w-80 rounded-full bg-lime-300/10 blur-3xl" />

      <form
        onSubmit={handleLogin}
        className="theme-login-card relative w-full max-w-md rounded-[2rem] border border-white/15 bg-white/95 p-8 shadow-2xl backdrop-blur"
      >
        <p className="text-center text-xs font-semibold uppercase tracking-[0.4em] text-emerald-700">
          Genmech Service
        </p>
        <h1 className="mt-4 text-center text-3xl font-black text-slate-950">
          Engineer Workspace Login
        </h1>
        <p className="mt-3 text-center text-sm leading-6 text-slate-600">
          Sign in with your email or engineer ID to open your field dashboard and service work.
        </p>

        <div className="mt-8 space-y-5">
          <div>
            <label className="mb-2 block text-sm font-semibold text-slate-700">
              Email or Engineer ID
            </label>
            <input
              type="text"
              placeholder="ENG-1024 or engineer@genmech.com"
              className="w-full rounded-2xl border border-emerald-100 px-4 py-3 outline-none transition focus:border-emerald-500 focus:ring-4 focus:ring-emerald-100"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              required
            />
          </div>

          <div>
            <label className="mb-2 block text-sm font-semibold text-slate-700">Password</label>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              className="w-full rounded-2xl border border-emerald-100 px-4 py-3 outline-none transition focus:border-emerald-500 focus:ring-4 focus:ring-emerald-100"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword((prev) => !prev)}
              className="mt-2 text-sm font-medium text-emerald-700 transition hover:text-emerald-900"
            >
              {showPassword ? "Hide Password" : "Show Password"}
            </button>
          </div>

          {errorMessage ? (
            <div className="rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700">
              {errorMessage}
            </div>
          ) : null}
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="mt-8 w-full rounded-2xl bg-emerald-600 px-4 py-3 font-semibold text-white transition hover:bg-emerald-500 disabled:cursor-not-allowed disabled:bg-emerald-300"
        >
          {isSubmitting ? "Signing In..." : "Login"}
        </button>

        <div className="mt-6 text-center text-sm">
          <Link to="/" className="font-semibold text-emerald-700 transition hover:text-emerald-900">
            Back to role select
          </Link>
        </div>
      </form>
    </div>
  );
}

export default EngineerLogin;


